import * as React from 'react';
import { useContext, useEffect, useState } from "react";
import { Box, Typography, useTheme } from "@mui/material";
import { DataGrid, GridOverlay } from "@mui/x-data-grid";
import { tokens,ColorModeContext } from "../../theme";
import CircularProgress from '@mui/material/CircularProgress';
import { mockDataInvoices } from "../../data/mockData";
import Header from "../../components/Header";
import Stack from '@mui/material/Stack';
import Tooltip from '@mui/material/Tooltip';
import Grid from '@mui/material/Grid';
import ConnString from "../../ConnString.js";

 
 
const Connstring2 = ConnString.connstring;
 


const TLServiceContracts = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const colorMode = useContext(ColorModeContext);

  const [columns, setColumns] = useState([]);
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);



    const CustomLoadingOverlay = () => (
    <GridOverlay>
     <CircularProgress />
    </GridOverlay>
    );


  const fetchHeader = async () => {
    try {
      const response = await fetch(`${Connstring2}/api/TranslistHeader`, {
        method: 'POST',
        credentials: "include",
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          moduleID: 'ACTSRC',
          transType: 'ACTSRC',
          type: 'ColumnNames',
        }),
      });

      const data = await response.json();

      const rawFields = data.columns;

      const estimateWidth = (field, sampleRow = {}) => {
      const sampleText = sampleRow[field] ?? field;
      return Math.max(100, sampleText.toString().length * 10); // crude estimate
      };


      // const columnDefs = rawFields.map((field) => ({
      //   field,
      //   headerName: field.replace(/([A-Z])/g, ' $1').replace(/^./, str => str.toUpperCase()), // Format: CustCode → Cust Code
      //   flex: 1,
      //   minWidth: 100, // Adjust depending on expected content length
      // }));
      const columnDefs = rawFields.map((field) => ({
        field,
        headerName: field.replace(/([A-Z])/g, ' $1').replace(/^./, str => str.toUpperCase()),
        width: estimateWidth(field, rows[0]), // based on first row
      }));


      setColumns(columnDefs);


      // console.log("Columns from server:", data.columns); // ← use for DataGrid columns

    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };
const fetchData = async () => {
    try {
      const response = await fetch(`${Connstring2}/api/TranslistData`, {
        method: 'POST',
        credentials: "include",
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          moduleID: 'ACTSRC',
          transType: 'ACTSRC',
          dateFrom: '9/1/2024',
          dateTo: '6/19/2025',
          filter: `and Branch= 'M0001'`,
        }),
      });

     const data = await response.json();

      if (!data.columns || !Array.isArray(data.columns)) {
      console.error("Invalid row data:", data);
      setRows([]); // or show an error message
      return;
      }

      
      const transformedRows = data.columns.map((row) => ({
        ...row,
        id: row.RecID,
      }));

    setRows(transformedRows);

    console.log("rows from server:", data); // ← use for DataGrid columns

    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
  const loadData = async () => {
    setLoading(true);
    await fetchHeader();
    await fetchData();
    setLoading(false);
  };
  loadData();
  }, []);


  const [alignment, setAlignment] = React.useState('web');

  const handleChange = (event, newAlignment) => {
    setAlignment(newAlignment);
  };

  const handleClick = () => console.log("Icon clicked");


  const icons = [
    { src: "../systemicons/new_96px.png", title: "NEW" },
    { src: "../systemicons/clone32.png", title: "CLONE" },
    { src: "../systemicons/edit_96px.png", title: "EDIT" },
    { src: "../systemicons/View_32.png", title: "VIEW" },
    { src: "../systemicons/unpost_32.png", title: "UNPOST" },
  ];



  const LoadingOverlay = () => (
    <Box
      position="absolute"
      top={0}
      left={0}
      width="100%"
      height="100%"
      zIndex={1000}
      display="flex"
      alignItems="center"
      justifyContent="center"
      backdropFilter="blur(4px)" // ← blur effect
      bgcolor="rgba(255,255,255,0.3)" // semi-transparent white overlay
    >
      <CircularProgress />
    </Box>
  );

  return (
    <Box m="20px">
      <Header title="Service Contracts" subtitle="List of Service Contracts" />

      <div style={{ width: "50px", height: "10px" } } >
        <Grid>
          <Stack direction="row" spacing={1} mb={2}>
        {icons.map((icon, idx) => (
          <Tooltip key={idx} title={icon.title}>
            <button
              onClick={handleClick}
              style={{ border: "none", background: "none", padding: 0 }}
            >
              <img
                src={icon.src}
                alt={icon.title}
                style={{
                  width: "32px",
                  height: "32px",
                  objectFit: "contain",
                  cursor: "pointer",
                }}
              />
            </button>
          </Tooltip>
        ))}
      </Stack>
      </Grid>
     </div>

     

       <Box
        m="40px 0 0 0"
        height="75vh"
        sx={{
          "& .MuiDataGrid-root": {
            border: "none",
          },
          "& .MuiDataGrid-cell": {
            borderBottom: "none",
          },
          "& .name-column--cell": {
            color: colors.greenAccent[300],
          },
          "& .MuiDataGrid-columnHeaders": {
            backgroundColor: colors.blueAccent[700],
            borderBottom: "none",
          },
          "& .MuiDataGrid-virtualScroller": {
            backgroundColor: colors.primary[400],
          },
          "& .MuiDataGrid-footerContainer": {
            borderTop: "none",
            backgroundColor: colors.blueAccent[700],
          },
          "& .MuiCheckbox-root": {
            color: `${colors.greenAccent[200]} !important`,
          },
        }}
      >
        
                
          <Box position="relative" m="40px 0 0 0" height="75vh" sx={"MuiDataGrid-root"}>
          {loading && <LoadingOverlay />}
          <DataGrid
            loading={loading}
            rows={rows}
            columns={columns}
            checkboxSelection
            getRowId={(row) => row.RecID}
          />
        </Box>
      </Box>
    </Box>
  );
};

export default TLServiceContracts;